import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { helpdeskRoutes } from '../../routes/helpdeskRoutes';
import { useHelpdeskHomePath } from '../../hooks/useHelpdeskHomePath';

type SidebarItem = {
  label: string;
  path: string;
  icon: string;
  description: string;
};

const settingsItems: SidebarItem[] = [
  {
    label: 'Caixas de Entrada',
    path: helpdeskRoutes.settingsInboxes,
    icon: 'M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z',
    description: 'WhatsApp, e-mail, widget e demais canais',
  },
  {
    label: 'Robôs',
    path: helpdeskRoutes.settingsBots,
    icon: 'M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z',
    description: 'Bots IA e webhooks',
  },
  {
    label: 'Grupos',
    path: helpdeskRoutes.settingsGroups,
    icon: 'M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10',
    description: 'Filas e roteamento',
  },
  {
    label: 'Etiquetas',
    path: helpdeskRoutes.settingsLabels,
    icon: 'M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z',
    description: 'Tags de conversa',
  },
  {
    label: 'Respostas prontas',
    path: helpdeskRoutes.settingsCannedResponses,
    icon: 'M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z',
    description: 'Atalhos de mensagem',
  },
  {
    label: 'Assinatura',
    path: helpdeskRoutes.settingsUserSignature,
    icon: 'M4 6h16M4 12h16M4 18h10M17 16l3 3m0 0l-3 3m3-3h-6',
    description: 'Texto e imagem nas suas respostas',
  },
  {
    label: 'Indicadores',
    path: helpdeskRoutes.settingsIndicators,
    icon: 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z',
    description: 'Metas e indicadores do POP',
  },
  {
    label: 'Configurações gerais',
    path: helpdeskRoutes.settingsGeneral,
    icon: 'M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z',
    description: 'Pipeline bTalk, auto-resolução e agentes de IA',
  },
];

const atendimentoItems: SidebarItem[] = [
  {
    label: 'Dashboard',
    path: helpdeskRoutes.dashboard,
    icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6',
    description: 'Visão geral e ações rápidas',
  },
  {
    label: 'Atendimento',
    path: helpdeskRoutes.workspace,
    icon: 'M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z',
    description: 'Fila e conversas em atendimento',
  },
  {
    label: 'Minhas notificações',
    path: helpdeskRoutes.inbox,
    icon: 'M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4',
    description: 'Conversas das caixas em que você é membro',
  },
  {
    label: 'Contatos',
    path: helpdeskRoutes.contacts,
    icon: 'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z',
    description: 'Contatos do atendimento',
  },
];

export const AtendimentoSidebar: React.FC<{
  mobileOpen: boolean;
  onMobileClose: () => void;
}> = ({ mobileOpen, onMobileClose }) => {
  const location = useLocation();
  const { user } = useAuth();
  const { homePath } = useHelpdeskHomePath();
  const [collapsed, setCollapsed] = useState(false);

  const isSettingsPanel = location.pathname.startsWith(helpdeskRoutes.settings);
  const menuItems = isSettingsPanel ? settingsItems : atendimentoItems;

  const isActive = (path: string) => {
    if (path === helpdeskRoutes.dashboard)
    {
      return location.pathname === helpdeskRoutes.dashboard || location.pathname === `${helpdeskRoutes.dashboard}/`;
    }

    if (path === helpdeskRoutes.workspace)
    {
      return location.pathname === helpdeskRoutes.workspace;
    }

    return location.pathname === path || location.pathname.startsWith(`${path}/`);
  };

  const roleCode = (user?.role?.code ?? '').toLowerCase();
  const roleLabel = user?.isAdmin || roleCode === 'admin'
    ? 'Administrador'
    : roleCode === 'manager'
      ? 'Gerente'
      : 'Atendente';

  return (
    <>
      {mobileOpen && (
        <button
          type="button"
          className="fixed inset-0 z-40 bg-black/40 lg:hidden"
          aria-label="Fechar menu"
          onClick={onMobileClose}
        />
      )}
      <aside
        className={`bg-white shadow-md flex flex-col flex-shrink-0 z-50 h-full min-h-0 fixed inset-y-0 left-0 w-64 transition-transform duration-200 lg:static lg:z-40 ${
          collapsed ? 'lg:w-20' : 'lg:w-64'
        } ${mobileOpen ? 'translate-x-0' : '-translate-x-full pointer-events-none lg:pointer-events-auto lg:translate-x-0'}`}
      >
      <div className="flex flex-col h-full min-h-0">
        <div
          className={`border-b border-gray-200 flex items-center justify-between p-4 ${
            collapsed ? 'lg:flex-col lg:items-center lg:gap-1 lg:px-2 lg:py-3' : ''
          }`}
        >
          <img src="/logo.png" alt="Logo" className="h-8" />
          <button
            className="lg:hidden flex items-center justify-center p-2 rounded hover:bg-gray-100 focus:outline-none"
            onClick={onMobileClose}
            aria-label="Fechar menu"
            type="button"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
          <button
            className="hidden lg:flex items-center justify-center p-2 rounded hover:bg-gray-100 focus:outline-none"
            onClick={() => {
              setCollapsed((current) => !current);
            }}
            aria-label={collapsed ? 'Expandir menu' : 'Recolher menu'}
            type="button"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              {collapsed ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              )}
            </svg>
          </button>
        </div>

        <div className="lg:hidden px-3 py-3 border-b border-gray-200 space-y-1">
          <Link
            to={homePath}
            onClick={onMobileClose}
            className={`block rounded-md px-3 py-2 text-sm font-medium ${
              !isSettingsPanel ? 'bg-blue-50 text-blue-700' : 'text-gray-700 hover:bg-gray-50'
            }`}
          >
            Atendimento
          </Link>
          <Link
            to={helpdeskRoutes.settings}
            onClick={onMobileClose}
            className={`block rounded-md px-3 py-2 text-sm font-medium ${
              isSettingsPanel ? 'bg-blue-50 text-blue-700' : 'text-gray-700 hover:bg-gray-50'
            }`}
          >
            Configurações
          </Link>
        </div>

        {(!collapsed || mobileOpen) && (
          <div className={`px-4 py-2 border-b border-gray-200 ${collapsed ? 'lg:hidden' : ''}`}>
            <div className="text-xs text-gray-500 uppercase tracking-wide">Função</div>
            <div className="text-sm font-medium text-gray-900">{roleLabel}</div>
          </div>
        )}

        <nav className="flex-1 overflow-y-auto py-4">
          <ul>
            {menuItems.map(item => (
              <li key={item.path} className="mb-2">
                <Link
                  to={item.path}
                  onClick={onMobileClose}
                  className={`flex items-center px-4 py-2 rounded-md transition-colors duration-150 ${
                    isActive(item.path)
                      ? 'bg-blue-50 text-blue-600 border-l-4 border-l-blue-600'
                      : 'text-gray-600 hover:bg-gray-50 border-l-4 border-l-transparent'
                  } ${collapsed ? 'lg:justify-center' : ''}`}
                  title={collapsed ? item.label : undefined}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className={`h-5 w-5 mr-3 ${collapsed ? 'lg:mr-0' : ''} ${
                      isActive(item.path) ? 'text-blue-600' : 'text-gray-600'
                    }`}
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={item.icon} />
                  </svg>
                  <div className={`flex flex-col min-w-0 ${collapsed ? 'lg:hidden' : ''}`}>
                    <span className="font-medium truncate">{item.label}</span>
                    <span className="text-xs text-gray-500 truncate">{item.description}</span>
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>
      </aside>
    </>
  );
};
